module.exports = __webpack_public_path__ + "static/media/hatziq_resume_2025_04_19.2b1d5227.pdf";